<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row videoWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/material/m-icon3.png"/><span>视频点播</span>
            <router-link :to="{ name: 'VideoPage', query: { name: '视频点播' }}" class="more right">更多</router-link>
          </div>
          <div class="col-xs-12 col-sm-7 col-md-7">
            <div class="page-video">
              <video-player  class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions">
              </video-player>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-5 page-other-video">
            <div class="col-xs-12 col-sm-12 col-md-12 noPadding page-video-list" :class="activeClass == idx ? 'active':''" v-for="(item,idx) in videoList" :key="idx" @click="vedioPlay(item.id, idx)">
                <div class="col-xs-4 col-sm-4 col-md-4 noPadding page-img"><img :src="globalVar.imgUrl+item.coverurl"/></div>
                <div class="col-xs-8 col-sm-8 col-md-8 page-video-title"><v-clamp autoresize :max-lines="1">{{item.title}}</v-clamp><em>{{item.createtime}}</em></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row otherWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/material/m-icon1.png"/><span>资料下载</span>
            <router-link :to="{ name: 'FilePage', query: { name: '资料下载' }}" class="more right">更多</router-link>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-6 col-md-6" v-for="(item,idx) in downloadList" :key="idx" @click="detail(item.id,item.title)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/material/m-icon2.png"/><span>历史资料</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in historyList" :key="idx" @click="hisHandle(item)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row proWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/material/m-icon4.png"/><span>世界政要名流谈投洽会</span>
            <router-link :to="{ name: 'VideoListSpaPage', query: { name: '世界政要名流谈投洽会' }}" class="more right">更多</router-link>
          </div>
          <div class="row page-pro">
            <div class="col-xs-12 col-sm-3 col-md-3 page-pro-list" v-for="(sitem, sidx) in soundplayArr" :key="sidx" @click="soundPlay(sitem.id)">
              <div class="page-pro-main">
                <img :src="globalVar.imgUrl+sitem.coverurl"/>
                <h3><v-clamp autoresize :max-lines="2">{{sitem.title}}</v-clamp></h3>
                <!-- <p><v-clamp autoresize :max-lines="1">世界投资促进机构协会主席</v-clamp></p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subMenuBar from '@/components/subMenuBar/subMenuBar'
import VClamp from 'vue-clamp'
import 'video.js/dist/video-js.css'
import {videoPlayer} from 'vue-video-player'
export default {
  components: {
    subMenuBar,
    VClamp,
    videoPlayer
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.material,
      tabList: ["9月7号","9月8号","9月9号","9月10号","9月11号"],
      tabIndex: 0,
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" //你的视频地址（必填）
        }],
        poster: "http://119.23.240.159:8089/cifit/img/banner.6f93c6620190419145604.png", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true  //全屏按钮
        }
      },
      historyList:[
        {
          title: '历史回望',
          pathName: 'BackHisPage',
          name: '历史回望'
        },
        {
          title: '历届简要回顾',
          pathName: 'HisMPage',
          name: '历届回顾'
        },
        {
          title: '历届成果图表',
          pathName: 'pdfMPage',
          name: '历届成果图表'
        },
        {
          title: '历届论坛讲稿汇编',
          pathName: 'lectureFPage',
          name: '历届论坛研讨会讲稿汇编'
        },
        {
          title: '历届参展商',
          pathName: 'SearchPage',
          name: '展商信息'
        },
        {
          title: '历届团组名单',
          pathName: 'pdfMPage',
          name: '历届团组'
        },
        {
          title: '历届赞助机构',
          pathName: 'SponsorPage',
          name: '历届赞助机构'
        },
        {
          title: '历届精彩照片',
          pathName: 'HisPicPage',
          name: '历届精彩照片'
        },
        {
          title: '历届视频点播',
          pathName: 'VideoPage',
          name: '视频点播'
        },
        // {
        //   title: '投洽会10周年回顾展',
        //   pathName: 'reviewPage',
        //   name: '投洽会10周年回顾展'
        // },
        {
          title: '投洽会20周年回顾展',
          pathName: 'MemoryPage',
          name: '投洽会20周年回顾展'
        },
        {
          title: '投洽会20周年纪念画册',
          pathName: 'MemoryPage',
          name: '投洽会20周年纪念画册'
        },
        {
          title: '历届主宾国',
          pathName: 'HisGuest',
          name: '历届主宾国',
          type: 1
        },
        {
          title: '历届主宾省',
          pathName: 'HisGuest',
          name: '历届主宾省',
          type: 2
        },
        // {
        //   title: '国际投资快报',
        //   pathName: 'INTexpressM',
        //   name: '国际投资快报'
        // },
      ],
      activeClass: 0,
      videoList: Array,
      soundplay: Array,
      downloadList: Array,
    }
  },
  async created(){
    await this.init();
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    soundplayArr: function(){
      return this.soundplay.slice(0, 4);
    }
  },
  methods: {
    subpagemenu(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.subName,
        }
      })
    },
    hisHandle(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.name,
          type: item.type? item.type:''
        }
      })
    },
    async init(){
      let data = await this.mainVideo(4);//4：视频点播
      this.videoList = data.slice(0, 3);
      let id  = this.videoList[0].id;
      this.vedioPlay(id, this.activeClass);
      this.soundplay = await this.mainVideo(5);//5：世界政要名流谈投洽会
      let downlist = await this.dataList(); //资料下载 
      this.downloadList = downlist.slice(0, 8);
    },
    mainVideo(type){
      let params = {
        counts: '',
        type,
        language: this.globalVar.lang
      }
      return this.$store.dispatch("mainVideo", params);
    },
    async vedioPlay(id, idx){
      let params = {
        id
      }
      this.activeClass = idx; 
      let data = await this.$store.dispatch("videoInfo", params);
      this.playerOptions.sources[0].src = this.globalVar.imgUrl+data.fileurl;
      this.playerOptions.poster = this.globalVar.imgUrl+data.coverurl;
    },
    soundPlay(id){
      this.$router.push({
        name: 'VideoSpaPage',
        query: {
          name: '世界政要名流谈投洽会',
          id, 
        }
      })
    },
    dataList(){
      let params = {
        language: this.globalVar.lang
      }
      return this.$store.dispatch("dataList", params);
    },
    detail(id,title){
      this.$router.push({
        name: 'FileDataPage',
        query: {
          name: '资料下载',
          id: id,
          title: title
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import '../../static/function.less';
.otherWrap{
  .page-header-news{
    margin-top: 3%;
  }
  .page-pic{
    padding: 2% 0;
    text-align: center;
    cursor: pointer;
  }
  .page-list{
    margin-top: 5%;
    padding: 0 3%;
    cursor: pointer;
    p{
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover{
        .hoverTxtColor()
      }
      &:before{
        content:''; 
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }
}
.videoWrap{
  .page-video{
    width: 90%;
    margin: 15px auto;
  }
  .page-video-list{
    font-size: 14px;
    margin: 8px 0px;
    cursor: pointer;
    &:hover{
      .page-video-title{
        color: @colorea0e1e;
      }
    }
    &.active{
      .page-video-title{
        color: @colorea0e1e;
      }
    }
  }
  .page-other-video{
    margin-top: 15px;
    .page-video-title{
      padding: 0px;
      padding-left: 15px;
      height: 44px;
      margin: 4% 0;
      em{
        font-size: 12px;
        color: @color767676;
        display: inline-block;
        margin-top: 10px;
      }
    }
  }
}
.proWrap{
  margin-bottom: 3%;
  .page-pro{
    margin: 15px 0px;
    .page-pro-list{
      margin: 15px 0px;
      .page-pro-main{
        text-align: center;
        font-size: @font14;
        cursor: pointer;
        h3{
          font-size: @font18;
          font-weight: 400;
          margin-top: 3%;
        }
        p{
          font-size: @font14;
          color: #333;
          margin-top: 3%;
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 767px){
  .slideMenu{
    display: block;
  }
  .page-video-list{
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Material.vue